<template>
  <div class="intro">
    <div class="intro__headline">
      3 More, 3 Less. <br />
      Built for Business Impact
    </div>
    <div class="intro__bodycopy">
      LG MAGNIT is LG’s advanced Micro LED display, designed to deliver
      exceptional picture quality and reliability for professional environments.
      With the "3 More, 3 Less" concept, it brings superior image quality while
      making operation and management simpler for businesses.
    </div>
  </div>
</template>
<script>
export default {
  name: 'Intro',
}
</script>

<style lang="scss" scoped>
@import '@/scss/function.scss';
.intro {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 68px;
  &__headline {
    font-family: 'LG EI Headline';
    font-weight: 600;
    font-size: 52px;
    line-height: 60px;
    text-align: center;
  }
  &__bodycopy {
    font-size: 24px;
    line-height: 32px;
    font-weight: 400;
    color: #000;
    text-align: center;
  }
  @media screen and (max-width: 1080px) {
    gap: calcQuarter(124);
    padding: 0 calcQuarter(60);
    &__headline {
      font-size: calcQuarter(108);
      line-height: calcQuarter(118);
    }
    &__bodycopy {
      font-size: calcQuarter(56);
      line-height: calcQuarter(70);
    }
  }
}
</style>
